import { render } from "./departments-index.vue?vue&type=template&id=06a9af43"
import script from "./departments-index.vue?vue&type=script&lang=js"
export * from "./departments-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__